import { DataTableProvider } from 'components/DataTable'
import React from 'react'

import { IColumnVisibility } from 'components/DataTable/types'

import { ColumnsStoreProvider } from 'stores/ColumnsStore/ColumnsStoreProvider'
import { PlacesSummary } from '../../../models/summaries'

import { featureFlagService } from 'utils/featureFlagService'
import { DoorsTableComponentV2 } from './DoorsTableComponentV2'
import { DoorsTableComponent } from './DoorsTableComponent'
import { IContactCompany } from '../../../models/contact_companies'

export interface IDoorsTableProps {
  chainFilter?: number
  setDoorsSummary?: React.Dispatch<React.SetStateAction<PlacesSummary>>
  hideTitle?: boolean
  disableUrlPagination?: boolean
  tableKey: string
  tableKeyForColumnOrdering?: string
  /**
   * When provided, enables "Create Door" button in footer instead of "Create Company".
   * Used when viewing doors within a specific company context (e.g., in DoorsModal).
   */
  chainProxy?: IContactCompany
  /**
   * Table key for the unmatched doors table. Used to invalidate/refetch queries
   * when a new door is created from the matched tab.
   */
  unmatchedTableKey?: string
}

export function DoorsTable(
  props: IDoorsTableProps & {
    defaultColumnVisibility?: IColumnVisibility<any>
    initialColumnOrder?: string[]
  }
) {
  const {
    tableKey,
    tableKeyForColumnOrdering,
    defaultColumnVisibility,
    initialColumnOrder,
    ...rest
  } = props

  const { enabledReportDoors, isLoading } = featureFlagService()

  if (isLoading) {
    return null
  }

  if (enabledReportDoors) {
    return (
      <ColumnsStoreProvider
        savedPresetsIdentifier={'DOORS_TABLE'}
        tableKey={tableKeyForColumnOrdering ?? tableKey}
        defaultColumnVisibility={defaultColumnVisibility}
        initialColumnOrder={initialColumnOrder}
        preferredGroupOrder={[
          'Target Attributes',
          'Campaigns and Deals',
          'Predicted Values',
          'Reputation Data',
          'Location Data',
        ]}
      >
        <DataTableProvider tableKey={tableKey}>
          <DoorsTableComponentV2 tableKey={tableKey} {...rest} />
        </DataTableProvider>
      </ColumnsStoreProvider>
    )
  }

  return (
    <ColumnsStoreProvider
      savedPresetsIdentifier={'DOORS_TABLE'}
      tableKey={tableKeyForColumnOrdering ?? tableKey}
      defaultColumnVisibility={defaultColumnVisibility}
      initialColumnOrder={initialColumnOrder}
      preferredGroupOrder={[
        'Target Attributes',
        'Campaigns and Deals',
        'Predicted Values',
        'Reputation Data',
        'Location Data',
      ]}
    >
      <DataTableProvider tableKey={tableKey}>
        <DoorsTableComponent tableKey={tableKey} {...rest} />
      </DataTableProvider>
    </ColumnsStoreProvider>
  )
}
